import i18n from "@/i18n"; // 引入 I18n 套件

const knowFroms = ['mail', 'magazine', 'leaflet', 'google', 'yahoo', 'facebook_ig', 'referral', 'other'];
export const main = {
    install(Vue, option) {
        i18n.init(option.config).then(oI18n => {
            // **************** 認識這課程途徑
            const knowFromOptions = knowFroms.map(key => {
                return { value: key, text: oI18n.t(`knownFromOptions.${key}`) };
            });
            Vue.prototype.$knowFromOptions = knowFromOptions;
        })
    }
}

export const knowFromList = knowFroms;
export const gradeList = ['K1', 'K2', 'K3', 'PP1', 'P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'S1', 'S2', 'S3', 'S4', 'S5', 'S6'];